import styles from './h1.module.scss';
import cx from 'classnames';
import { UiTheme } from '@greenkub-fronts/shared/interface';

type H1Color = 'green' | 'white' | 'black' | 'purple';

export interface H1Props {
  color?: H1Color | string;
  className?: string;
  children?: React.ReactElement;
  theme?: UiTheme;
  value?: string;
  bold?: boolean;
  style?: any;
}

export const H1 = (props: H1Props) => {
  const { color, className, children, theme, value, bold, style } = props;

  return (
    <h1
      className={cx(
        styles['h1'],
        color && styles[color],
        theme && styles[theme],
        bold && styles['bold'],
        className
      )}
      style={style}
    >
      {value ? value : <span>{children}</span>}
    </h1>
  );
};

export default H1;
